// Common IANA timezones offered as quick picks at the top of the selector.
export const POPULAR_TIMEZONE_NAMES = [
    'Europe/London',
    'Europe/Dublin',
    'Europe/Paris',
    'America/New_York',
    'America/Los_Angeles',
    'UTC',
];

// Fallback list used when the browser does not expose Intl.supportedValuesOf.
const FALLBACK_TIMEZONES = [
    'UTC',
    'Europe/London',
    'Europe/Dublin',
    'Europe/Paris',
    'Europe/Berlin',
    'Europe/Madrid',
    'Europe/Rome',
    'Europe/Amsterdam',
    'Europe/Zurich',
    'Europe/Stockholm',
    'Europe/Athens',
    'Europe/Istanbul',
    'Europe/Moscow',
    'America/New_York',
    'America/Chicago',
    'America/Denver',
    'America/Los_Angeles',
    'America/Toronto',
    'America/Sao_Paulo',
    'America/Mexico_City',
    'Asia/Dubai',
    'Asia/Kolkata',
    'Asia/Singapore',
    'Asia/Hong_Kong',
    'Asia/Shanghai',
    'Asia/Tokyo',
    'Asia/Seoul',
    'Australia/Sydney',
    'Pacific/Auckland',
];

const getAllTimezones = () => {
    try {
        if (typeof Intl.supportedValuesOf === 'function') {
            const values = Intl.supportedValuesOf('timeZone');
            if (Array.isArray(values) && values.length > 0) {
                // Ensure UTC is always selectable.
                return values.includes('UTC') ? values : ['UTC', ...values];
            }
        }
    } catch {
        // Fall through to the static list.
    }
    return FALLBACK_TIMEZONES;
};

export const TIMEZONES = getAllTimezones();

// Returns the current UTC offset for a timezone as a label like "UTC+01:00".
export const getTimezoneOffsetLabel = (timeZone) => {
    try {
        const parts = new Intl.DateTimeFormat('en-GB', {
            timeZone,
            timeZoneName: 'shortOffset',
        }).formatToParts(new Date());
        const name = parts.find((p) => p.type === 'timeZoneName')?.value;
        if (!name) return '';
        if (name === 'GMT') return 'UTC+00:00';
        return name.replace('GMT', 'UTC');
    } catch {
        return '';
    }
};

export const formatTimezoneLabel = (timeZone) => {
    if (!timeZone) return '';
    return timeZone.replace(/_/g, ' ');
};
